export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const MAKE_APP_READY = "MAKE_APP_READY";
